import React from "react";

interface LoadingProps {
  message?: string;
  size?: "sm" | "md" | "lg" | "xl";
  variant?: "spinner" | "hourglass" | "dots";
  className?: string;
  centered?: boolean;
  fullPage?: boolean;
}

export const Loading: React.FC<LoadingProps> = ({
  message = "Carregando...",
  size = "md",
  variant = "hourglass",
  className = "",
  centered = true,
  fullPage = false,
}) => {
  const sizeClasses = {
    sm: "text-lg",
    md: "text-2xl",
    lg: "text-4xl",
    xl: "text-5xl",
  };

  const messageSizeClasses = {
    sm: "text-sm",
    md: "text-base",
    lg: "text-lg",
    xl: "text-xl",
  };

  const spinnerSizeClasses = {
    sm: "w-4 h-4 border-2",
    md: "w-6 h-6 border-2",
    lg: "w-8 h-8 border-2",
    xl: "w-12 h-12 border-4",
  };

  const getLoadingIcon = () => {
    switch (variant) {
      case "spinner":
        return (
          <div
            className={`animate-spin rounded-full border-gray-300 dark:border-slate-600 border-t-blue-600 dark:border-t-[#63B3ED] ${spinnerSizeClasses[size]}`}
          />
        );
      case "dots":
        return (
          <div className="flex space-x-1">
            {[0, 1, 2].map((i) => (
              <div
                key={i}
                className={`bg-blue-600 rounded-full animate-bounce ${
                  size === "sm"
                    ? "w-1 h-1"
                    : size === "md"
                    ? "w-2 h-2"
                    : size === "lg"
                    ? "w-3 h-3"
                    : "w-4 h-4"
                }`}
                style={{ animationDelay: `${i * 0.1}s` }}
              />
            ))}
          </div>
        );
      case "hourglass":
      default:
        return <span className={`animate-spin ${sizeClasses[size]}`}>⏳</span>;
    }
  };

  const containerClasses = `
    ${fullPage ? "fixed inset-0 bg-white dark:bg-slate-800 bg-opacity-90 dark:bg-opacity-95 z-50" : ""}
    ${centered ? "flex flex-col items-center justify-center" : ""}
    ${fullPage ? "min-h-screen" : centered ? "py-8" : ""}
    animate-fade-in
    ${className}
  `.trim();

  return (
    <div className={containerClasses}>
      <div className="flex flex-col items-center gap-4">
        {getLoadingIcon()}
        {message && (
          <p
            className={`font-medium text-gray-600 dark:text-slate-300 ${messageSizeClasses[size]}`}
          >
            {message}
          </p>
        )}
      </div>
    </div>
  );
};
